<!--<printheaderview [hasimage]="1">
</printheaderview>-->
<div class="">
  <div class="row">
    <div class="col-print-12 padding-left-0px">
      <div class="card background-color-wt">
        <div class="card-header background-color-wt padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
        <div class="card-body padding-top-10px padding-bottom-0px font-weight-normal background-color-wt">

          <div class="row">
            <div class="col-print-12 text-align-center">
              <label class="font-familyhead">Follicular Scan Report</label>
              <!--<qrcode class="padding-top-0px padding-bottom-0px qr-style2" [qrdata]="FormattedCode" [size]="90" [level]="'M'"></qrcode>-->

            </div>
            <!--<div class="col-print-1 padding-top-0px padding-bottom-0px"></div>-->
            <!--<qrcode class="padding-top-0px padding-bottom-0px qr-style2" [qrdata]="FormattedCode" [size]="90" [level]="'M'"></qrcode>-->

          </div>
          <!--<div class="row">
            <div class="col-print-10 text-align-center">
              <label class="margin-bottom-0px margin-top-0px font-familyhead"></label>
            </div>
            <div class="col-print-2 padding-top-0px padding-bottom-0px">
              <qrcode class="padding-top-0px padding-bottom-0px qr-style" [qrdata]="FormattedCode" [size]="90" [level]="'M'"></qrcode>
            </div>
          </div>-->

          <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-5 margin-top-10 margin-bottom-10px">
                <!--<div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Patient:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-bold">{{Owner}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Gender/Age:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Gender}}/{{Age}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Patient ID:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{FormattedCode}}</label>
                  </div>
                </div>-->

                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Scan Date:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DSADOC}} {{DSASTIMULATION}} {{DSAANTAG}} ({{DocDate | date:'dd-MMM-yyyy'}})</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Time:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DocDate | date:'hh:mm:ss'}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">LMP Date:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DocDate | date:'dd-MMM-yyyy'}}</label>
                  </div>
                </div>


                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Infertility Type:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Infertility}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px" *ngIf="EggSourceData=='DONOR' || EggSourceData=='Donor'">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Donor:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DonorData}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Doctor:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Sign1}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Doc:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Doc}}</label>
                  </div>
                </div>
              </div>

              <div class="col-print-1"></div>

              <div class="col-print-5 margin-top-10 margin-bottom-10px">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Cycle:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{CycleType}} ({{CycleNo}})</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Protocol:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Protocol}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Protocol Start:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Protocolst | date:'dd-MMM-yyyy'}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Protocol End:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{ProtocolEd | date:'dd-MMM-yyyy'}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px" *ngIf="EggSourceData=='DONOR' || EggSourceData=='Donor'">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Donor ID:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DonorCode}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Assistant Doctor:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Sign2}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-2">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>
          <!--<div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-5">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Scan Date:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DSADOC}} {{DSASTIMULATION}} {{DSAANTAG}} ({{DocDate | date:'dd-MMM-yyyy'}})</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Time:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DocDate | date:'hh:mm:ss'}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">LMP Date:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DocDate | date:'dd-MMM-yyyy'}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Doc:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Doc}}</label>
                  </div>
                </div>

              </div>

              <div class="col-print-1"></div>

              <div class="col-print-5">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Doctor:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Sign1}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Assistant Doctor:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Sign2}}</label>
                  </div>
                </div>

              </div>
            </div>
          </div>-->
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-normal">Endometrium Thickness:</label>
              </div>
              <div class="col-print-7" *ngIf="ScanDetail">
                <label class="margin-bottom-0px font-family float-left font-weight-normal">{{ScanDetail.EndometriumThickness}} {{ScanDetail.EndometriumThicknessUnits}}</label>
              </div>
            </div>
          </div>
          <!--<div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px" *ngIf="ScanDetail">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-7">
                <label class="margin-bottom-0px font-family13px float-left font-italic font-weight-normal">{{ScanDetail.EndometriumDetails}}</label>
              </div>
            </div>
          </div>-->
          <!--<div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-3">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>-->
          <div class="col-print-12" *ngIf="GradingModel=='Droplet Culture' && TcModel=='Fet' ">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-bold">Additional Details:</label>
              </div>
              <div class="col-print-7">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-normal">Blood Flow Zone:</label>
              </div>
              <div class="col-print-7">
                <label class="margin-bottom-0px font-family float-left font-weight-normal">{{ScanDetail.BloodFlowZone}}</label>
              </div>
            </div>
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-normal">Adjuvants:</label>
              </div>
              <div class="col-print-7">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-normal">Evion:</label>
              </div>
              <div class="col-print-7">
                <label class="margin-bottom-0px font-family float-left font-weight-normal">{{ScanDetail.Evion}}</label>
              </div>
            </div>
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-normal">Intauterine GCSF:</label>
              </div>
              <div class="col-print-7">
                <label class="margin-bottom-0px font-family float-left font-weight-normal">{{ScanDetail.GCSF}}</label>
              </div>
            </div>
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-normal">BAPC:</label>
              </div>
              <div class="col-print-7">
                <label class="margin-bottom-0px font-family float-left font-weight-normal">{{ScanDetail.BAPC}}</label>
              </div>
            </div>
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-1"></div>
              <div class="col-print-6">
                <div class="table-component margin-bottom-0px border4">
                  <div class="table-responsive">
                    <table class="table table-striped margin-left-zero">
                      <tr>
                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-center">

                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-left">
                          UterineArtery Left
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          UterineArtery Right
                        </th>

                      </tr>
                      <tr>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">RI</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{ScanDetail.RILeft}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{ScanDetail.RIRight}}</td>
                      </tr>
                      <tr>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">PI</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{ScanDetail.PILeft}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{ScanDetail.PIRight}}</td>
                      </tr>

                    </table>

                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="col-print-12">
            <!--<div class="row margin-left-0px margin-right-0px">
              <div class="col-print-3">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>-->
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-3">
                <label class="margin-bottom-0px font-family font-weight-normal">Tests:</label>
              </div>
              <div class="col-print-8">
                <!--<div class="row" *ngFor="let l of CurrentIvfCycleTestByCodeController">
                  <div class="col-print-6 padding-left-15px">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.TestName}}</label>
                  </div>
                </div>-->
              </div>
            </div>

            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-1"></div>
              <div class="col-print-10">
                <div class="table-component margin-bottom-0px border4">
                  <div class="table-responsive">
                    <table class="table table-striped margin-left-zero">
                      <tr>
                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-center">
                          S.No
                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-left">
                          Test Name
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Result
                        </th>

                      </tr>
                      <tr *ngFor="let l of CurrentIvfCycleTestByCodeController ; let RowIndex = index ">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{RowIndex+1}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.TestName}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.Result}}{{l.ResultUnits}}</td>
                      </tr>

                    </table>

                  </div>
                </div>
              </div>
            </div>

            <!--<div class="row margin-left-0px margin-right-0px">
              <div class="col-print-3">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>-->
            <!--<div class="row margin-left-0px margin-right-0px">
              <div class="col-print-3">
                <label class="margin-bottom-0px font-family font-weight-normal">Result:</label>
              </div>
              <div class="col-print-8">
                <div class="row" *ngFor="let l of CurrentIvfCycleTestByCodeController">
                  <div class="col-print-6 padding-left-15px">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.Result}} {{l.ResultUnits}}</label>
                  </div>
                </div>
              </div>
            </div>-->
            <!--<div class="row margin-left-0px">
              <div class="col-print-3">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>-->
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-3">
                <label class="margin-bottom-0px font-family font-weight-normal">Medicines:</label>
              </div>
              <div class="col-print-8">
                <!--<div class="row" *ngFor="let l of CurrentIvfCycleMedicineByCodeController">
                  <div class="col-print-6 padding-left-15px">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.MedicineName}}</label>
                  </div>
                </div>-->

              </div>

            </div>
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-1"></div>
              <div class="col-print-10">
                <div class="table-component margin-bottom-0px border4">
                  <div class="table-responsive">
                    <table class="table table-striped margin-left-zero">
                      <tr>
                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-center">
                          S.No
                        </th>
                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-left">
                          Date
                        </th>
                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-left">
                          Medicine Name
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Dose
                        </th>

                      </tr>
                      <tr *ngFor="let l of CurrentIvfCycleMedicineByCodeController ; let RowIndex = index ">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{RowIndex+1}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.StartDate| date:'MMM-dd-yyyy'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.MedicineName}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.Dosage}} {{l.DurationType}}</td>
                      </tr>

                    </table>

                  </div>
                </div>
              </div>
            </div>
            <!--<div class="row margin-left-0px margin-right-0px">
              <div class="col-print-3">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>-->
            <!--<div class="row margin-left-0px margin-right-0px">
              <div class="col-print-3">
                <label class="margin-bottom-0px font-family font-weight-normal">Dose:</label>
              </div>
              <div class="col-print-8">
                <div class="row" *ngFor="let l of CurrentIvfCycleMedicineByCodeController">
                  <div class="col-print-6 padding-left-15px">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.Dosage}} {{l.DurationType}}</label>
                  </div>
                </div>
              </div>
            </div>-->
            <!--<div class="row margin-left-0px">
              <div class="col-print-3">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>-->
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-12 text-align-left">
                <label class="margin-bottom-0px font-family font-weight-normal">Ovaries</label>
                <label class="margin-bottom-0px font-family font-weight-normal">(Count/Size):</label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-1">

              </div>
              <div class="col-print-3 text-align-left">
                <div class="table-component margin-bottom-0px border4">
                  <div class="table-responsive overflow-x-hidden">

                    <table class="table table-striped margin-left-zero">

                      <thead>
                        <tr class="">
                          <th colspan="2" class="font-family padding-top-2px padding-bottom-2px text-align-center font-weight-normal">Left</th>

                        </tr>
                      </thead>
                      <tbody class="table-body">
                        <tr>

                          <td class="font-family padding-top-2px padding-bottom-2px text-align-center">Count</td>
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-center">Size</td>

                        </tr>
                        <ng-container *ngFor="let l of CurrentFollicularScanOvaryDetailController">
                          <tr *ngIf="l.OvarPos == 'Left'|| l.OvarPos == 'LEFT'">
                            <td class="td-padding text-align-center font-family">

                              <!--<label *ngIf="l.OvarPos == 'Left' || 'LEFT' && l.OvarPos != 'Right' || 'RIGHT' ">{{l.Count}}</label>-->
                              <label class="margin-bottom-0px">{{l.Count}}</label>

                            </td>
                            <td class="td-padding text-align-center font-family">

                              <!--<label *ngIf="l.OvarPos == 'Left' || 'LEFT' && l.OvarPos != 'Right' || 'RIGHT' ">{{l.Size}}</label>-->

                              <label class="margin-bottom-0px">{{l.Size}}</label>

                            </td>

                          </tr>
                        </ng-container>

                        <!--<tr *ngFor="let l of CurrentFollicularScanOvaryDetailController">

                          <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.Count}}</td>
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.Size}}</td>

                        </tr>-->

                      </tbody>

                    </table>
                  </div>
                </div>
              </div>
              <div class="col-print-3 text-align-left padding-left-15px">
                <div class="table-component margin-bottom-0px border4">
                  <div class="table-responsive overflow-x-hidden">

                    <table class="table table-striped margin-left-zero">

                      <thead>
                        <tr class="">

                          <th colspan="2" class="font-family padding-top-2px padding-bottom-2px text-align-center font-weight-normal">Right</th>
                        </tr>
                      </thead>
                      <tbody class="table-body">

                        <tr class="">

                          <td class="font-family padding-top-2px padding-bottom-2px text-align-center">Count</td>
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-center">Size</td>

                        </tr>
                        <ng-container *ngFor="let l of CurrentFollicularScanOvaryDetailController">
                          <tr *ngIf="l.OvarPos == 'Right'|| l.OvarPos == 'RIGHT'">
                            <td class="td-padding text-align-center font-family">

                              <label class="margin-bottom-0px">{{l.Count}}</label>


                            </td>
                            <td class="td-padding text-align-center font-family">

                              <label class="margin-bottom-0px">{{l.Size}}</label>


                            </td>

                          </tr>
                        </ng-container>
                        <!--<tr class="">

                          <td class="font-family padding-top-2px padding-bottom-2px text-align-center">1</td>
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-center">2</td>

                        </tr>-->

                      </tbody>

                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--<div class="col-print-12">
            <div class="row margin-left-0px">
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>-->
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-3">
                <label class="margin-bottom-0px font-family margin-top-8px font-weight-normal">AFC Count:</label>
              </div>
              <div class="col-print-8 padding-left-15px">
                <label class="margin-bottom-0px font-family margin-top-8px font-weight-normal">{{AFCCount}}</label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-3">
                <label class="margin-bottom-0px font-family margin-top-8px font-weight-normal">Next Scan Date:</label>
              </div>
              <div class="col-print-8 padding-left-15px" *ngIf="ScanDetail">
                <label class="margin-bottom-0px font-family margin-top-8px font-weight-normal">{{ScanDetail.NextDocDate | date:'dd-MMM-yyyy'}}</label>
              </div>

            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-3">
                <label class="margin-bottom-0px font-family margin-top-8px font-weight-normal">Comments:</label>
              </div>
              <div class="col-print-8 padding-left-15px" *ngIf="ScanDetail">
                <label class="margin-bottom-0px font-family margin-top-8px font-weight-normal">{{ScanDetail.Comments}}</label>
              </div>

            </div>
          </div>
          <!--<div class="pagebrk"></div>-->
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family">Doctor</label>
              </div>
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family">Assistant</label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-8">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-7 border-bot-1px">
                    <label class="margin-bottom-0px font-family text-align-center">{{Sign1}}</label>
                  </div>
                  <!--<div class="col-print-6">
                    <label class="margin-bottom-0px font-family"></label>
                  </div>-->
                </div>
              </div>
              <div class="col-print-4">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-12 border-bot-1px">
                    <label class="margin-bottom-0px font-family text-align-center">{{Sign2}}</label>
                  </div>
                  <!--<div class="col-print-5">
                    <label class="margin-bottom-0px font-family"></label>
                  </div>-->
                </div>
              </div>
            </div>
          </div>



        </div>
      </div>
    </div>
  </div>
</div>
<!--<printfooterview [Sign1]="Sign1" [Sign2]="Sign2"></printfooterview>-->
